module.exports = "/static/Images/en/positive.png";